"use client";

import { PopoverProps } from "@radix-ui/react-popover";
import * as React from "react";
import { DateRange } from "react-day-picker";
import { Button, ButtonProps } from "@/components/atoms/Button";
import { Calendar, CalendarProps } from "@/components/molecules/Calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/molecules/Popover";
import CalendarIcon from "@/icons/__generated__/Calendar/Calendar20";
import { cn } from "@/lib/utils";
import { getDisplayedValue, hasValue } from "./date-picker-utils";

export interface DatePickerProps {
  value?: Date | Date[] | DateRange | undefined;
  onValueChange?: (date: Date | Date[] | DateRange | undefined) => void;
  trigger?: React.ReactNode;
  calendarProps?: Partial<CalendarProps>;
  triggerProps?: Partial<ButtonProps>;
  fullWidth?: boolean;
  placeholder?: React.ReactNode;
  popoverProps?: PopoverProps;
  testId?: string;
  disabled?: boolean;
  dateFormat?: string;
  displayCalendarIcon?: boolean;
  contentClassName?: string;
}

export const DatePicker = ({
  dateFormat,
  value,
  onValueChange,
  trigger,
  calendarProps,
  triggerProps,
  fullWidth,
  placeholder,
  popoverProps,
  testId = "date-picker",
  disabled,
  displayCalendarIcon = true,
  contentClassName,
}: DatePickerProps) => {
  return (
    <Popover {...popoverProps}>
      <PopoverTrigger asChild>
        {trigger || (
          <Button
            variant="outline-1"
            appearance="white"
            prefix={
              displayCalendarIcon ? (
                <CalendarIcon className="tw-text-gray-900" />
              ) : null
            }
            fullWidth={fullWidth}
            alignment="left"
            truncate={true}
            disabled={disabled}
            testId={testId ? `${testId}-trigger` : undefined}
            {...(triggerProps || {})}
            className={cn(
              "tw-body-2 hover:tw-bg-base-white",
              { "tw-text-gray-600": !hasValue(value) },
              triggerProps?.className,
            )}
          >
            {getDisplayedValue(value, placeholder, dateFormat)}
          </Button>
        )}
      </PopoverTrigger>
      <PopoverContent
        className={cn("tw-w-auto tw-p-0", contentClassName)}
        align="start"
      >
        <Calendar
          mode="single"
          selected={value as any}
          onSelect={onValueChange}
          {...((calendarProps || {}) as CalendarProps)}
        />
      </PopoverContent>
    </Popover>
  );
};
